export const ClientAccount = {
  DELETED: 'deleted',
};
